import {Component, ViewEncapsulation} from "@angular/core";

@Component({
    selector     : '.date-picker-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Date Picker</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm">
        <check-box [(ngModel)]="model.required" name="required" label="Is Required" labelPlacement="after"></check-box>
        <date-picker
                name="minDate"
                label="Minimum Date"
                [(ngModel)]="model.minDate"></date-picker>
        <date-picker
                name="maxDate"
                label="Maximum Date"
                [(ngModel)]="model.maxDate"></date-picker>
        <date-picker
                name="testDatepicker"
                label="Test Date Picker"
                [(ngModel)]="model.value"
                [required]="model.required"
                [minDate]="model.minDate"
                [maxDate]="model.maxDate"></date-picker>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<div class="alert alert-info">
    Please include the following css file for the date picker styles.
    <pre class="card card-body bg-light">/node_modules/ngx-bootstrap/datepicker/bs-datepicker.css</pre>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class DatePickerDemoComponent {

    model = {
        value   : null,
        required: false,
        minDate : new Date(),
        maxDate : new Date()
    };

    markup = `
<date-picker
     name="testDatepicker"
     label="Test Date Picker"
     [(ngModel)]="model.value"
     [required]="model.required"
     [minDate]="model.minDate"
     [maxDate]="model.maxDate"></date-picker>
    `;

    constructor() {
        let minDate = new Date();
        minDate.setMonth(minDate.getMonth() - 1);
        let maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 1);
        this.model.minDate = minDate;
        this.model.maxDate = maxDate;
    }

}
